import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Yii } from 'libraries/interfaces/Yii';
import { ILabels } from 'libraries/interfaces/ILabels';
import { ISectorData } from './flight-details.service';
import { DateService } from "libraries/date/date.service";
import { BtnStyleTypes } from "libraries/ui_button/btn.component";
import { faClock, faCalendar, IconDefinition } from "@fortawesome/free-solid-svg-icons";

class Wording {
    public readonly show: string = Yii.t('wui-iqba-js', 'Afficher les détails des vols');
    public readonly hide: string = Yii.t('wui-iqba-js', 'Cacher les détails des vols');
    public readonly sectorTitle: string = Yii.t('wui-iqba-js', 'Secteur');
    public readonly beginAt: string = Yii.t('wui-iqba-js', 'Départ le');
    public readonly endAt: string = Yii.t('wui-iqba-js', 'Arrivée le');
    public readonly close: string = Yii.t('wui-iqba-js', 'Masquer les détails');
    public readonly endUnknown: string = Yii.t('wui-iqba-js', 'Arrivée inconnue');
    public readonly beginUnknown: string = Yii.t('wui-iqba-js', 'Départ inconnue');
    public readonly durationUnknown: string = Yii.t('wui-iqba-js', 'Durée inconnue');
}

@Component({
    selector: 'flight-details',
    template: `
        <div class="flight-details">
            <div class="hide-container" *ngIf="showCloseBtn">
                <btn click-stop
                     [type]="btnType.actionLink"
                     [label]="flightDetailsLabels.close"
                     (click)="close()">
                </btn>
            </div>
            <div class="sector-air-flight-details">
                <div class="sector-information">
                    <fa-icon [icon]="iconCalendar" class="icon"></fa-icon>
                    <ng-container *ngIf="sector.begin; else beginUnknown">

                    <span class="no-wrap">{{ flightDetailsLabels.beginAt }}
                        <strong>
                            {{ sector.begin | dateMoment: dateService.dateFormats.momentMedium }}
                            {{ sector.begin | dateMoment: dateService.dateFormats.momentTime }}
                        </strong>
                    </span>
                    </ng-container>
                    <ng-template #beginUnknown>{{flightDetailsLabels.beginUnknown}}</ng-template>
                    -
                    <ng-container *ngIf="sector.end; else endUnknown">
                        <span class="no-wrap">{{ flightDetailsLabels.endAt }}
                            <strong>
                                {{ sector.end | dateMoment: dateService.dateFormats.momentMedium }}
                                {{ sector.end | dateMoment: dateService.dateFormats.momentTime }}
                            </strong>
                        </span>
                    </ng-container>
                    <ng-template #endUnknown><strong>{{flightDetailsLabels.endUnknown}}</strong></ng-template>
                    <ng-container *ngIf="sector.begin && sector.end; else durationUnknown">
                        -
                        <span class="no-wrap">
                            <fa-icon [icon]="iconClock" class="icon"></fa-icon><strong>{{ sector.duration }}</strong>
                        </span>
                    </ng-container>
                    <ng-template #durationUnknown>
                        -
                        <span class="no-wrap">
                            <fa-icon [icon]="iconClock" class="icon"></fa-icon><strong>{{ flightDetailsLabels.durationUnknown }}</strong>
                        </span>
                    </ng-template>

                </div>
                <sector-air-flight-details [sectorData]="sector"
                                           [showCarbonFootprint]="true"></sector-air-flight-details>
                <div *ngIf="sector.durationStop" class="time">
                    <fa-icon [icon]="iconClock"></fa-icon>
                    {{ sector.durationStop }}
                </div>
            </div>
        </div>
    `,
    styles: [`
        .sector-information {
            padding: .75rem .75rem 0 .75rem;
        }

        .icon {
            margin-right: 5px;
        }

        .time {
            padding: .75rem;
            background-color: #f2f2f2;
            border: 1px solid rgba(189, 195, 199, 0.2);
            color: #848282;
        }

        .time .fa-clock-o {
            margin-right: 5px;
        }

        .no-wrap {
            white-space: nowrap;
        }
        .hide-container{
            text-align: right;
        }
    `]
})
export class FlightDetailsComponent {
    @Input()
    public sector: ISectorData;
    @Input()
    public showCloseBtn: boolean;

    @Output()
    public readonly onClose: EventEmitter<void> = new EventEmitter<void>();

    public btnType: typeof BtnStyleTypes = BtnStyleTypes;

    public iconClock: IconDefinition = faClock;

    public iconCalendar: IconDefinition = faCalendar;

    public flightDetailsLabels: Wording = new Wording();

    constructor(public readonly dateService: DateService) {
    }

    public close(): void {
        this.onClose.emit();
    }
}
